// extracted by mini-css-extract-plugin
export var WelcomeOverlay = "V_dx";
export var aniBgLoading = "V_f";
export var aniSpin = "V_d";
export var bg = "V_T";
export var body = "V_bj";
export var bodyText = "V_dC";
export var close = "V_dz";
export var closeButton = "V_dD";
export var grid = "V_7";
export var head = "V_dB";
export var header = "V_s";
export var header__inner = "V_bg";
export var heading = "V_t";
export var inner = "V_k";
export var scroll = "V_dy";